import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import { buildElasticGraphQLParams } from '../selectors/converterSelector';
import config from '../store/_config';

export const axiosRequestOrders = (listParams) => {
    let { url, query } = config.order.listing;

    if (listParams) {
        ['Status', 'Status:not', 'ShippingStatus', 'PaymentMethod'].forEach(
            (key) => {
                if (
                    typeof listParams.filters != 'undefined' &&
                    typeof listParams.filters[key] != 'undefined'
                ) {
                    if (
                        !Array.isArray(listParams.filters[key]) &&
                        listParams.filters[key]
                    ) {
                        listParams.filters[key] = [listParams.filters[key]];
                    }
                }
            }
        );
    }

    let params = buildElasticGraphQLParams(listParams);

    query = query.replace(/{params}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestOrder = (listParams) => {
    let { url, query } = config.order.detail;
    let params = buildElasticGraphQLParams(listParams);

    query = query.replace(/{params}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosPayOrder = (payload) => {
    let { url, query } = config.order.pay;

    return axios.post(
        url,
        { id: query, variables: payload },
        {
            withCredentials: true,
        }
    );
};

export const axiosUpdateOrder = (payload) => {
    let { url, query } = config.order.update;

    return axios.post(
        url,
        { id: query, variables: { Input: payload } },
        {
            withCredentials: true,
        }
    );
};

export const axiosEditPlacedOrder = (id) => {
    let { url, query } = config.order.editPlacedOrder;

    return axios.post(
        url,
        {
            query: query,
            variables: { ID: Number(id) }
        },
        {
            withCredentials: true,
        }
    );
};

export const getAxiosParamForApproval = (query, params) => {
    let axiosParams;

    if (params.OperatorCode !== undefined) {
        query = query.replace(/{mutationParams}/, `($OperatorCode: String!)`);
        query = query.replace(/{params}/, `ID: ${params.ID}, OperatorCode: $OperatorCode`);

        axiosParams = {
            query: query,
            variables: {
                OperatorCode: params.OperatorCode,
            }
        };
    }
    else if (params.ResellerPurchaseOrder !== undefined) {
        query = query.replace(/{mutationParams}/, `($ResellerPurchaseOrder: String!)`);
        query = query.replace(/{params}/, `ID: ${params.ID}, ResellerPurchaseOrder: $ResellerPurchaseOrder`);

        axiosParams = {
            query: query,
            variables: {
                ResellerPurchaseOrder: params.ResellerPurchaseOrder,
            }
        };
    }

    return axiosParams;
};

export const axiosApprovalOrder = (params) => {
    let { url, query } = config.order.approval;
    const axiosParams = getAxiosParamForApproval(query, params);

    const axiosConfig = {
        withCredentials: true,
    };

    return axios.post(url, axiosParams, axiosConfig);
};

export const axiosRejectOrder = (params) => {
    let { url, query } = config.order.reject;
    const axiosParams = getAxiosParamForApproval(query, params);

    const axiosConfig = {
        withCredentials: true,
    };

    return axios.post(url, axiosParams, axiosConfig);
};

export const axiosContactCustomerOrder = (params) => {
    let { url, query } = config.order.contactCustomer;
    const axiosParams = getAxiosParamForApproval(query, params);

    const axiosConfig = {
        withCredentials: true,
    };

    return axios.post(url, axiosParams, axiosConfig);
};

export const axiosViewOrderSettings = (id) => {
    let { url, query } = config.order.viewOrderSettings;

    return axios.post(
        url,
        {
            query: query,
            variables: { ID: Number(id) }
        },
        {
            withCredentials: true,
        }
    );
};
export const axiosPlaceBackOrder = (id, buyables, freightAmount, trackingNumber) => {
    let { url, query } = config.order.placeBackOrder;

    return axios.post(
        url,
        {
            query: query,
            variables: { OrderID: Number(id), Buyables: buyables, FreightAmount: freightAmount, TrackingNo: trackingNumber }
        },
        {
            withCredentials: true,
        }
    );
};


export const axiosReOrderSettings = (id) => {
    let { url, query } = config.order.reOrderSettings;

    return axios.post(
        url,
        {
            query: query,
            variables: { ID: Number(id) }
        },
        {
            withCredentials: true,
        }
    );
};
export const axiosReOrderCartUpdate = (cartdata) => {
    let { url, query } = config.cart.addReOrderCustomTag;
    return axios.post(
        url,
        {
            query: query,
            variables: {
                Buyables: cartdata,
            },
        },
        {
            withCredentials: true,
        }
    );
};
export const updateOrderFreight = (params, callback) => {
    console.log("params ==> ", params);
    console.log("callBacks ==> ", callback);
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosUpdateOrderFreight(params)
            .then((response) => {
                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};
export const axiosUpdateOrderFreight = (params) => {
    let { url, query } = config.order.updateOrderFreight;

    let data = {
        id: query,
        variables: params,
    };

    console.log("Data to send ==> ", data);

    return axios.post(url, data, {
        withCredentials: true,
    });
};
